"use client";

import { Heart, History, LogOut, User, UserPen } from "lucide-react";
import { useTranslations } from "next-intl";
import { toast } from "sonner";
import { Link } from "@/i18n/navigation";
import { AnalyticsEvents, resetUser, trackEvent } from "@/lib/client/analytics/product-analytics";
import { authClient, useSession } from "@/lib/client/auth/client";
import { useLoadingStore } from "@/lib/client/stores";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/ui";

/**
 * UserAccountNavItems component - User account menu items
 */
export const UserAccountNavItems = () => {
  const usersT = useTranslations("users");
  const toastT = useTranslations("toast");
  const { setIsLoading } = useLoadingStore();
  const { data: _session } = useSession();

  const handleSignOut = async () => {
    setIsLoading(true);
    try {
      const result = await authClient.signOut();
      if (result.error) {
        toast.error(result.error.message);
      } else {
        trackEvent(AnalyticsEvents.AUTH_SIGN_OUT_CLICKED);
        resetUser();
        toast.success(toastT("success.log_out"), {
          description: toastT("success.title"),
          duration: 5000,
        });
      }
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Failed to sign out");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMenuOpen = () => {
    trackEvent(AnalyticsEvents.ACCOUNT_MENU_OPENED);
  };
  return (
    <DropdownMenu onOpenChange={(open) => open && handleMenuOpen()}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={usersT("account_menu")}
        >
          <User className="!h-5 !w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-50 w-40">
        <Link href="/user/profile">
          <DropdownMenuItem>
            <UserPen className="mr-2 h-5 w-5" />
            {usersT("profile")}
          </DropdownMenuItem>
        </Link>
        <Link href="/user/wishlist">
          <DropdownMenuItem>
            <Heart className="mr-2 h-5 w-5" />
            {usersT("wishlist")}
          </DropdownMenuItem>
        </Link>
        <Link href="/user/orders">
          <DropdownMenuItem>
            <History className="mr-2 h-5 w-5" />
            {usersT("order_history")}
          </DropdownMenuItem>
        </Link>
        {/* {session?.user && (
          <Link href={`/affiliate/${session.user.id}`}>
            <DropdownMenuItem>
              <BadgeDollarSign className="mr-2 h-5 w-5" />
              {usersT("affiliate")}
            </DropdownMenuItem>
          </Link>
        )} */}
        <DropdownMenuItem onClick={handleSignOut}>
          <LogOut className="mr-2 h-5 w-5" />
          {usersT("sign_out")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
